import { useCallback, useEffect } from 'react';
import * as d3 from 'd3';

const useD3Tooltip = (className) => {
  const getTooltip = useCallback(() => {
    const existing = d3.select(document.body).select(`.${className}`);
    if (!existing.empty()) return existing;
    return d3.select(document.body).append('div').attr('class', className);
  }, [className]);

  const hideTooltip = useCallback(() => {
    getTooltip().style('display', 'none');
  }, [getTooltip]);

  const showTooltip = useCallback(
    (html) => {
      getTooltip()
        .style('display', 'block')
        .style('top', d3.event.pageY + 20 + 'px')
        .style('left', d3.event.pageX + 20 + 'px')
        .html(html);
    },
    [getTooltip]
  );

  useEffect(() => {
    return () => {
      d3.select(document.body).select(`.${className}`).remove();
    };
  }, [className]);

  return { showTooltip, hideTooltip };
};

export default useD3Tooltip;
